<template>
  <oxd-layout
    v-bind="$attrs"
    :notification-total="notificationCount.total"
    :notification-new="notificationCount.new"
    @notification:show-all-notification="showAllNotification"
  >
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
    <template #user-actions>
      <li>
        <a
          href="#"
          role="menuitem"
          class="oxd-userdropdown-link"
          @click="openAboutModel"
        >
          <oxd-icon type="svg" name="about" :with-container="false" />
          {{ $t('general.about') }}
        </a>
      </li>
      <li>
        <a :href="supportUrl" role="menuitem" class="oxd-userdropdown-link">
          <oxd-icon type="svg" name="support" :with-container="false" />{{
            $t('general.support')
          }}
        </a>
      </li>
      <li v-if="updatePasswordUrl">
        <a
          :href="updatePasswordUrl"
          role="menuitem"
          class="oxd-userdropdown-link"
        >
          <oxd-icon
            type="svg"
            name="changePassword"
            :with-container="false"
          />{{ $t('general.change_password') }}
        </a>
      </li>
      <li>
        <a
          :href="logoutUrl"
          role="menuitem"
          class="oxd-userdropdown-link"
          style="background-color: #ffdedeff; color: #ff4b4bff"
        >
          <oxd-icon type="svg" name="logout" :with-container="false" />{{
            $t('general.logout')
          }}
        </a>
      </li>
    </template>
    <template #user-notification>
      <div v-for="notification in notifications" :key="notification.id">
        <li
          class="notification-item"
          :class="{'notification-item-new': !notification.isRead}"
        >
          <div class="notification-icon-container">
            <oxd-icon
              v-if="notification.type === 'budget_exceeds'"
              name="wallet-fill"
              class="notification-icon-green"
            />
            <oxd-icon
              v-else-if="notification.type === 'document_expiry'"
              name="file-earmark-text-fill"
              class="notification-icon-green"
            />
            <oxd-icon v-else name="bell-fill" class="notification-icon-green" />
          </div>
          <div class="notification-content">
            <a @click="clickNavigateNotification(notification.link)">{{
              notification.content
            }}</a>
            <span class="notification-time">{{ notification.createdAt }}</span>
          </div>
        </li>
      </div>
    </template>
    <template #nav-actions>
      <!-- <div class="live-clock">
        <oxd-icon name="alarm-fill" />
        {{ currentTimeClock }}
      </div> -->
    </template>
  </oxd-layout>
  <about v-if="showAboutModel" @close="closeAboutModel"></about>
</template>

<script>
import {provide, readonly, ref, onBeforeMount} from 'vue';
import About from '@/core/pages/About.vue';
import {OxdLayout, OxdIcon} from '@ohrm/oxd';
import {APIService} from '@ohrm/core/util/services/api.service';
import {navigate} from '@ohrm/core/util/helper/navigation';
import {formatTimeAgo} from '@/core/util/helper/datefns';
import {dateFormatKey} from '@/core/util/composable/useDateFormat';

export default {
  components: {
    about: About,
    'oxd-layout': OxdLayout,
    'oxd-icon': OxdIcon,
  },
  inheritAttrs: false,
  props: {
    permissions: {
      type: Object,
      default: () => ({}),
    },
    logoutUrl: {
      type: String,
      default: '#',
    },
    supportUrl: {
      type: String,
      default: '#',
    },
    updatePasswordUrl: {
      type: String,
      default: '#',
    },
    dateFormat: {
      type: Object,
      default: null,
    },
    helpUrl: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const showAboutModel = ref(false);
    provide('permissions', readonly(props.permissions));
    provide(dateFormatKey, readonly(props.dateFormat));

    const notifications = ref([]);
    const notificationCount = ref([]);
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/core/notification',
    );

    const openAboutModel = () => {
      showAboutModel.value = true;
    };

    const closeAboutModel = () => {
      showAboutModel.value = false;
    };

    const onClickSupport = () => {
      if (props.helpUrl) window.open(props.helpUrl, '_blank');
    };

    const showAllNotification = () => {
      navigate('/core/notification');
    };

    onBeforeMount(() => {
      http.getAll({limit: 10}).then(({data}) => {
        notifications.value = data.data.map((item) => {
          return {
            id: item.id,
            type: item.type,
            content: item.content,
            link: item.link,
            isRead: item.isRead,
            createdAt: formatTimeAgo(item.createdAt?.date),
          };
        });
        notificationCount.value = {
          new: data.meta.newNotification,
          total: data.meta.total,
        };
      });
    });

    return {
      showAllNotification,
      onClickSupport,
      showAboutModel,
      openAboutModel,
      closeAboutModel,
      notifications,
      notificationCount,
    };
  },
  methods: {
    clickNavigateNotification(link) {
      navigate(link);
    },
  },
};
</script>
<style lang="scss" scoped>
.live-clock {
  font-weight: bold;
  margin-top: 6px;
  display: flex;
  justify-content: space-between;
  gap: 8px;
}
</style>
<style src="../../styles/notification.scss" lang="scss" scoped></style>
